@let request = $request();
@let compactMode = mobileRequestsListCompactMode();

@if (compactMode) {
  <div
    class="x-card x-card_size_s x-white mb-2 px-0 pt-0 pb-2"
    [routerLink]="requestRoute"
  >
    <section
      class="h-[32px] rounded-t-(--tui-radius-xl) px-2 py-1.5 flex items-center gap-1"
      [style.background]="hexToRgba(request.statusId?.color!, 0.5)"
    >
      <div class="me-1 h-full flex items-center shrink-0">
        <x-svg-icon
          [icon]="leaseProductIconResolver(request.carType, request.carModel)"
          class="x-icon-svg car-type-icon-cp inline!"
        ></x-svg-icon>
      </div>
      <div class="x-font-paragraph-s font-extrabold truncate flex-1">
        {{ request.requestNumber }}
      </div>
      <div class="x-font-paragraph-s font-extrabold truncate text-right">
        {{ 'request_statuses.' + request.statusId?.id | translate }}
      </div>
    </section>
    <section class="mt-2 px-2.5">
      <div class="text-[15px]/[22px] font-extrabold">
        {{ request.releaseTime | releaseTimeParser }}
        @if (request.releaseDate) {
          <span>, {{ request.releaseDate | date: 'dd.MM' }}</span>
        }
      </div>
      <p class="font-extrabold text-[12px]/[16px] mt-1">{{ request.car }}</p>
      @if (request.carPlantNumber) {
        <p class="text-[10px]/[14px] mt-1 text-(--tui-text-tertiary)">
          {{ request.carPlantNumber }}
        </p>
      }
      <p class="text-[10px]/[14px] mt-1 text-(--tui-text-tertiary)">
        {{
          request.deliveryAddress ||
            ('requests_list_item.undefined_address' | translate)
        }}
      </p>
    </section>
    <section class="mt-2 px-2.5 flex flex-col gap-1">
      @for (
        product of request.alternativeProducts;
        track product.productAssocId
      ) {
        <div
          class="rounded-xl bg-(--x-white-secondary) px-2 py-1 text-[10px]/[14px]"
        >
          <div class="font-extrabold">{{ product.productName }}</div>
          <div class="text-(--tui-text-tertiary)">
            @if (product.scheduledAt) {
              {{ product.scheduledAt | date: 'dd.MM.yyyy HH:mm' }}
            } @else if (product.displayDate) {
              {{ product.displayDate | date: 'dd.MM.yyyy' }}
              {{ request.releaseTime | releaseTimeParser }}
            } @else {
              {{ 'requests_list_item.undefined_date' | translate }}
            }
          </div>
        </div>
      }
    </section>
  </div>
} @else {
  <div
    class="x-card x-card_size_m x-white mb-2 px-0 pt-0"
    [routerLink]="requestRoute"
  >
    <section
      class="h-[38px] rounded-t-(--tui-radius-xl) px-4 py-2 flex items-center justify-between"
      [style.background]="hexToRgba(request.statusId?.color!, 0.5)"
    >
      <div class="x-font-header-s font-extrabold">
        {{ request.releaseTime | releaseTimeParser }},
        {{ request.releaseDate | date: 'dd.MM' }}
      </div>
      <div class="x-font-paragraph font-extrabold truncate text-right">
        {{ 'request_statuses.' + request.statusId?.id | translate }}
      </div>
    </section>
    <section class="mt-1 px-4 x-card__category flex items-center gap-2">
      <x-svg-icon
        [icon]="leaseProductIconResolver(request.carType, request.carModel)"
        class="x-icon-svg car-type-icon shrink-0"
      ></x-svg-icon>
      <div>
        <div class="x-font-paragraph-l font-extrabold overflow-wrap-anywhere">
          {{ request.car }}
        </div>
        @if (request.carPlantNumber) {
          <div class="text-[11px]/[16px] text-[var(--tui-text-tertiary)]">
            {{ request.carPlantNumber }}
          </div>
        }
      </div>
    </section>
    @if (request.contract) {
      <section class="px-4 mt-2">
        <p class="font-extrabold text-[15px]/[14px] flex items-center gap-1.5">
          <img
            [src]="counterpartyIconResolver(request.counterpartyOwnerId.id)"
            alt="cp icon"
            width="16"
            height="16"
            class="shrink-0"
          />
          {{ request.contract }}
        </p>
      </section>
    }
    <section class="px-4 mt-1 pb-1">
      <p class="typo-ui-s font-normal text-[10px]/[14px]">
        {{
          request.deliveryAddress ||
            ('requests_list_item.undefined_address' | translate)
        }}
      </p>
    </section>
    <section class="px-4 pb-4 pt-3 flex flex-col gap-2">
      @for (
        product of request.alternativeProducts;
        track product.productAssocId
      ) {
        <div class="rounded-xl bg-(--x-white-secondary) px-3 py-2">
          <div class="font-extrabold text-[13px]/[18px]">
            {{ product.productName }}
          </div>
          <div class="text-[11px]/[16px] text-(--tui-text-tertiary)">
            @if (product.scheduledAt) {
              {{ product.scheduledAt | date: 'dd.MM.yyyy HH:mm' }}
            } @else if (product.displayDate) {
              {{ product.displayDate | date: 'dd.MM.yyyy' }}
              {{ request.releaseTime | releaseTimeParser }}
            } @else {
              {{ 'requests_list_item.undefined_date' | translate }}
            }
          </div>
        </div>
      }
    </section>
  </div>
}
